
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AuthorisationsSettingsTable extends Vue {
  /**
   * Loading state of table.
   *
   * If any request is in progress table will not be presented
   */
  @Prop({ default: false }) loading!: boolean;

  /**
   * Hide table headers.
   *
   * If true, headers won't be showned
   */
  @Prop({ default: false }) hideHeaders!: boolean;

  get isStackedView() {
    return this.$mediaQuery.is('mdDown');
  }
}
